
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";

const RepresentativesForm = ({ father, mother, parentsDivorced, contactPerson1, contactPerson2, setFather, setMother, setParentsDivorced, setContactPerson1, setContactPerson2 }) => {

  //
  const updateFatherField = (field, value) => {
    let updated = {};
    updated[field] = value;
    setFather((s) => ({
      ...s,
      ...updated,
    }));
  };
  //
  const renderFatherListItem = (label, field, type = "text", additionalProps = {}, isSurfaceGround = true) => (
    <li className={`flex align-items-start py-2 px-2 flex-wrap ${isSurfaceGround ? "surface-ground" : ""}`}>
      <div className="text-500 w-full md:w-3 font-medium pr-2">{label}</div>
      {(type === "text" || type === "tel" || type === "email") ? <InputText
        type={type}
        disabled={field === "email"}
        className="p-inputtext-sm w-full md:w-9"
        value={father?.[field] || ""}
        onInput={(e) => {
          updateFatherField(field, type === "text" ? e.target.value?.toUpperCase() : e.target.value);
        }}
        {...additionalProps}
      /> : <Checkbox
        checked={father?.[field]}
        onChange={(e) => {
          updateFatherField(field, e.checked)
        }}
        {...additionalProps}
      />}
    </li>
  );
  //
  const updateMotherField = (field, value) => {
    let updated = {};
    updated[field] = value;
    setMother((s) => ({
      ...s,
      ...updated,
    }));
  };
  //
  const renderMotherListItem = (label, field, type = "text", additionalProps = {}, isSurfaceGround = true) => (
    <li className={`flex align-items-start py-2 px-2 flex-wrap ${isSurfaceGround ? "surface-ground" : ""}`}>
      <div className="text-500 w-full md:w-3 font-medium pr-2">{label}</div>
      {(type === "text" || type === "tel" || type === "email") ? <InputText
        disabled={field === "email"}
        type={type}
        className="p-inputtext-sm w-full md:w-9"
        value={mother?.[field] || ""}
        onInput={(e) => {
          updateMotherField(field, type === "text" ? e.target.value?.toUpperCase() : e.target.value);
        }}
        {...additionalProps}
      /> : <Checkbox
        checked={mother?.[field]}
        onChange={(e) => {
          updateMotherField(field, e.checked)
        }}
        {...additionalProps}
      />}
    </li>
  );
  //
  const updateContact1Field = (field, value) => {
    let updated = {};
    updated[field] = value;
    setContactPerson1((s) => ({
      ...s,
      ...updated,
    }));
  };
  //
  const renderContact1ListItem = (label, field, type = "text", additionalProps = {}, isSurfaceGround = true) => (
    <li className={`flex align-items-start py-2 px-2 flex-wrap ${isSurfaceGround ? "surface-ground" : ""}`}>
      <div className="text-500 w-full md:w-3 font-medium pr-2">{label}</div>
      {(type === "text" || type === "tel" || type === "email") ? <InputText
        type={type}
        className="p-inputtext-sm w-full md:w-9"
        value={contactPerson1?.[field] || ""}
        onInput={(e) => {
          updateContact1Field(field, type === "text" ? e.target.value?.toUpperCase() : e.target.value);
        }}
        {...additionalProps}
      /> : <Checkbox
        checked={contactPerson1?.[field]}
        onChange={(e) => {
          updateContact1Field(field, e.checked)
        }}
        {...additionalProps}
      />}
    </li>
  );
  const updateContact2Field = (field, value) => {
    let updated = {};
    updated[field] = value;
    setContactPerson2((s) => ({
      ...s,
      ...updated,
    }));
  };
  //
  const renderContact2ListItem = (label, field, type = "text", additionalProps = {}, isSurfaceGround = true) => (
    <li className={`flex align-items-start py-2 px-2 flex-wrap ${isSurfaceGround ? "surface-ground" : ""}`}>
      <div className="text-500 w-full md:w-3 font-medium pr-2">{label}</div>
      {(type === "text" || type === "tel" || type === "email") ? <InputText
        type={type}
        className="p-inputtext-sm w-full md:w-9"
        value={contactPerson2?.[field] || ""}
        onInput={(e) => {
          updateContact2Field(field, type === "text" ? e.target.value?.toUpperCase() : e.target.value);
        }}
        {...additionalProps}
      /> : <Checkbox
        checked={contactPerson2?.[field]}
        onChange={(e) => {
          updateContact2Field(field, e.checked)
        }}
        {...additionalProps}
      />}
    </li>
  );
  //
  return (
    <ul className="list-none p-0 m-0">
      <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Père</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            {renderFatherListItem("Nom de famille", "lastname", "text")}
            {renderFatherListItem("Prénom", "firstname", "text", {}, false)}
            {renderFatherListItem("Email", "email", "email")}
            {renderFatherListItem("Téléphone", "phone", "tel", {}, false)}
            {renderFatherListItem("Code postal", "postal_code")}
          </ul>
        </div>
      </li>
      <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Mère</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            {renderMotherListItem("Nom de famille", "lastname", "text")}
            {renderMotherListItem("Prénom", "firstname", "text", {}, false)}
            {renderMotherListItem("Email", "email", "email")}
            {renderMotherListItem("Téléphone", "phone", "tel", {}, false)}
            {renderMotherListItem("Code postal", "postal_code")}
          </ul>
        </div>
      </li>
      <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Famille</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">Situation familiale</div>
              <div className="text-900 w-full md:w-9">
                <div className="card flex flex-column md:flex-row gap-3">
                  <div className="flex align-items-start">
                    <RadioButton
                      checked={parentsDivorced === true}
                      onChange={(e) =>
                        setParentsDivorced(true)
                      }
                    />
                    <label className="ml-2">Divorcés</label>
                  </div>
                  <div className="flex align-items-start">
                    <RadioButton
                      checked={parentsDivorced === false}
                      onChange={(e) =>
                        setParentsDivorced(false)
                      }
                    />
                    <label className="ml-2">Mariés</label>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Autres personnes à contacter (sauf parents)</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            {renderContact1ListItem("Nom & prénom - Personne 1", "name", "text")}
            {renderContact1ListItem("Téléphone - Personne 1", "phone", "text", {}, false)}
            {renderContact2ListItem("Nom & prénom - Personne 2", "name", "text")}
            {renderContact2ListItem("Téléphone - Personne 2", "phone", "text", {}, false)}
          </ul>
        </div>
      </li>
    </ul >
  );
};

export default RepresentativesForm;